module.exports = __webpack_public_path__ + "img/457b95ce6031488282ee261baf3bddab_mergeImage.1373db4d.png";